// Base URL of the forms API server.
// Set REACT_APP_API_URL in .env.development / .env.production (not a secret).
// Empty means "same site as the frontend" (e.g. nginx forwards /api to the server).
// The dev site (dev.comsensetechnologies.com) always uses the dev API, whatever the build used.
const IS_DEV_SITE = typeof window !== "undefined" && window.location.hostname === "dev.comsensetechnologies.com";
export const API_BASE_URL = (
  IS_DEV_SITE ? "https://dev.api.comsensetechnologies.com" : process.env.REACT_APP_API_URL || ""
).replace(/\/+$/, "");

export const apiUrl = (path) => `${API_BASE_URL}${path}`;

// Headers for every form POST. The API rejects requests without the matching key
// (FORMS_API_KEY on the server). Note: like all REACT_APP_ values it is visible in
// the browser bundle, so it filters out casual/bot calls but is not a true secret.
export const apiHeaders = {
  "Content-Type": "application/json",
  "X-API-Key": process.env.REACT_APP_FORMS_API_KEY || "",
};
